export default "__VITE_ASSET__D_lt78mt__"